import SelectInput from "components/SelectInput";
import ChevronRight from "assets/images/svg/chevron-right.svg";
import ChevronLeft from "assets/images/svg/chevron-left.svg";
import ChevronFirst from "assets/images/svg/chevron-first.svg";
import ChevronEnd from "assets/images/svg/chevron-end.svg";

const CustomPagination = (props) => {
    const rowsPerPageOptions = props?.paginationRowsPerPageOptions?.map((number) => ({
        value: number,
        label: number.toString(),
    }));
    const selectedRowPerPage = {
        label: props?.rowsPerPage?.toString(),
        value: props?.rowsPerPage,
    };
    const isPrevBtnDisabled = props?.currentPage === 1,
        isBackToFirstBtnDisabled = props?.currentPage === 1,
        isNextBtnDisabled = props?.currentPage === Math.ceil(props?.rowCount / props?.rowsPerPage),
        isNextToLastBtnDisabled = props?.currentPage === Math.ceil(props?.rowCount / props?.rowsPerPage);
    return (
        <div className="d-flex justify-between align-center mt-5 flex-wrap table-pagination-container">
            <div className="d-flex align-center row-per-page">
                <label className="fw-400 mr-4">Rows per page</label>
                <SelectInput
                    isSearchable={false}
                    hideSelectedOptions={false}
                    className="table-row-per-page-select mb-0"
                    options={rowsPerPageOptions}
                    value={selectedRowPerPage}
                    onChange={(value) => props?.onChangeRowsPerPage(value?.value)}
                />
            </div>
            <div className="item-per-page">
                <label className="fw-400">
                    {props?.currentPage === 1
                        ? `1-${props?.rowsPerPage > props?.rowCount ? props?.rowCount : props?.rowsPerPage}`
                        : `${(props?.currentPage - 1) * props?.rowsPerPage + 1}-${
                              props?.rowsPerPage * props?.currentPage > props?.rowCount
                                  ? props?.rowCount
                                  : props?.rowsPerPage * props?.currentPage
                          }`}{" "}
                    of {props?.rowCount}
                </label>
            </div>
            <div className="d-flex table-pagination-btn-container">
                <div
                    className={`table-pagination-btn ${isBackToFirstBtnDisabled ? "disabled" : "active"}`}
                    onClick={() => (isBackToFirstBtnDisabled ? null : props?.onChangePage(1))}
                >
                    <ChevronFirst />
                </div>
                <div
                    className={`table-pagination-btn ${isPrevBtnDisabled ? "disabled" : "active"}`}
                    onClick={() => (isPrevBtnDisabled ? null : props?.onChangePage(props?.currentPage - 1))}
                >
                    <ChevronLeft />
                </div>
                <div
                    className={`table-pagination-btn ${isNextBtnDisabled ? "disabled" : "active"}`}
                    onClick={() => (isNextBtnDisabled ? null : props?.onChangePage(props?.currentPage + 1))}
                >
                    <ChevronRight />
                </div>
                <div
                    className={`table-pagination-btn ${isNextToLastBtnDisabled ? "disabled" : "active"}`}
                    onClick={() =>
                        isNextToLastBtnDisabled ? null : props?.onChangePage(Math.ceil(props?.rowCount / props?.rowsPerPage))
                    }
                >
                    <ChevronEnd />
                </div>
            </div>
        </div>
    );
};

export default CustomPagination;
